export default __webpack_public_path__ + "static/media/card1600.b1460e38.jpg";